import { Component } from 'react';
import DaySafetyElement from './DaySafetyElement';
import '@app/components/sqdp/all_factory/styles/safety-layout.css';
import dayjs from 'dayjs';

class SafetyLayout extends Component {
  state = {
    showInfo: false,
    element: {},
  };

  showInfo = (num) => {
    this.props.showIssueInfo(num, 1, this.props.factory);
  };

  getColorOfDayInt = (issueOfDay, dateNum) => {
    if (issueOfDay) {
      let thisDay = dayjs().date(dateNum).day();
      if (issueOfDay.isRestDay && (thisDay == 6 || thisDay == 0)) {
        return 'emtpy_state';
      }

      let today = dayjs();
      let selectedTime = dayjs(this.props.selectedMonth);
      if (
        today.get('month') <= selectedTime.get('month') &&
        today.get('year') <= selectedTime.get('year') &&
        dateNum > today.get('date')
      ) {
        return 'emtpy_state';
      }

      if (!issueOfDay.countSafetyTotal || issueOfDay.countSafetyTotal <= 0) {
        return 'green_state';
      }

      if (!issueOfDay.countSafetyIsAccident || issueOfDay.countSafetyIsAccident <= 0) {
        return 'yellow_state';
      }

      if (issueOfDay.countSafetyIsAccident > 0) {
        return 'red_state';
      }
    }

    return 'emtpy_state';
  };

  getColorOfDayCbm = (issueOfDay, dateNum) => {
    if (issueOfDay) {
      let thisDay = dayjs().date(dateNum).day();
      if (issueOfDay.isRestDay && (thisDay == 6 || thisDay == 0)) {
        return 'emtpy_state';
      }

      let today = dayjs();
      let selectedTime = dayjs(this.props.selectedMonth);
      if (
        today.get('month') <= selectedTime.get('month') &&
        today.get('year') <= selectedTime.get('year') &&
        dateNum > today.get('date')
      ) {
        return 'emtpy_state';
      }

      if (!issueOfDay.countSafetyTotal || issueOfDay.countSafetyTotal <= 0) {
        return 'green_state';
      }

      if (!issueOfDay.countSafetyIsAccident || issueOfDay.countSafetyIsAccident <= 0) {
        return 'yellow_state';
      }

      if (issueOfDay.countSafetyIsAccident > 0) {
        return 'red_state';
      }
    }

    return 'emtpy_state';
  };

  getColorOfDaySpa = (issueOfDay, dateNum) => {
    if (issueOfDay) {
      let thisDay = dayjs().date(dateNum).day();
      if (issueOfDay.isRestDay && (thisDay == 6 || thisDay == 0)) {
        return 'emtpy_state';
      }

      if (!issueOfDay.countSafetyTotal || issueOfDay.countSafetyTotal <= 0) {
        let today = dayjs();
        let selectedTime = dayjs(this.props.selectedMonth);
        if (
          today.get('month') <= selectedTime.get('month') &&
          today.get('year') <= selectedTime.get('year') &&
          dateNum == today.get('date')
        ) {
          return 'emtpy_state';
        }

        return 'green_state';
      }

      if (!issueOfDay.countSafetyIsAccident || issueOfDay.countSafetyIsAccident <= 0) {
        return 'yellow_state';
      }

      if (issueOfDay.countSafetyIsAccident > 0) {
        return 'red_state';
      }
    }

    return 'emtpy_state';
  };

  getColorOfDay = (
    issueOfDayFac,
    issueOfDayIqc,
    issueOfDayInt,
    issueOfDayCbm,
    issueOfDayWh,
    issueOfDaySpa,
    dateNum,
  ) => {
    let thisDay = dayjs().date(dateNum).day();
    if (issueOfDayFac) {
      let today = dayjs();
      let selectedTime = dayjs(this.props.selectedMonth);
      if (
        today.get('month') <= selectedTime.get('month') &&
        today.get('year') <= selectedTime.get('year') &&
        dateNum > today.get('date')
      ) {
        return 'emtpy_state';
      }

      const colorInt = this.getColorOfDayInt(issueOfDayInt, dateNum);
      const colorCbm = this.getColorOfDayCbm(issueOfDayCbm, dateNum);
      const colorSpa = this.getColorOfDaySpa(issueOfDaySpa, dateNum);

      if (
        colorInt === 'emtpy_state' &&
        colorCbm === 'emtpy_state' &&
        colorSpa === 'emtpy_state' &&
        (thisDay == 6 || thisDay == 0)
      ) {
        return 'emtpy_state';
      }

      if (
        ![colorInt, colorCbm, colorSpa].includes('yellow_state') &&
        ![colorInt, colorCbm, colorSpa].includes('red_state')
      ) {
        return 'green_state';
      }

      if ([colorInt, colorCbm, colorSpa].includes('red_state')) {
        return 'red_state';
      }

      return 'yellow_state';
    }

    return 'emtpy_state';
  };

  // closeInfo = () => {
  //   this.props.setState({ showInfo: false, element: {} })
  // }

  /**
   * Helper method that will generate a number of elements
   * from start index to end index to avoid copy pasting
   * all the hundred elements
   * @param {number} start
   * @param {number} end
   * @return {Array<Object>}
   */
  populateElements = (start, end) => {
    let items = [];
    for (let i = start; i <= end; i++) {
      let issueOfDayFac = this.props?.dataInMonthFac[i - 1];
      let issueOfDayIqc = this.props?.dataInMonthIqc[i - 1];
      let issueOfDayInt = this.props?.dataInMonthInt[i - 1];
      let issueOfDayCbm = this.props?.dataInMonthCbm[i - 1];
      let issueOfDayWh = this.props?.dataInMonthWh[i - 1];
      let issueOfDaySpa = this.props?.dataInMonthSpa[i - 1];
      let color = this.getColorOfDay(
        issueOfDayFac,
        issueOfDayIqc,
        issueOfDayInt,
        issueOfDayCbm,
        issueOfDayWh,
        issueOfDaySpa,
        i,
      );
      items.push(
        <DaySafetyElement
          oneTypeIssue={this.props.oneTypeIssue}
          showInfo={this.showInfo}
          color={color}
          num={i}
          issues={issueOfDayInt ? issueOfDayInt : {}}
          lastClickedElement={this.props.lastClickedElement}
          lastGroupClicked={this.props.lastGroupClicked}
        />,
      );
    }
    return items;
  };

  render() {
    return (
      <>
        <div id="table-safety">{this.populateElements(1, 32)}</div>
        {this.props.factory ? (
          <></>
        ) : (
          <h3 className="center" style={{ marginTop: '20px' }}>
            Safety
          </h3>
        )}
      </>
    );
  }
}

export default SafetyLayout;
